var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.25 21h-11.5c-1.517 0-2.75-1.233-2.75-2.75v-15.5c0-1.517 1.233-2.75 2.75-2.75h11.5c1.517 0 2.75 1.233 2.75 2.75v15.5c0 1.517-1.233 2.75-2.75 2.75z",
    fill: "#1976d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 0h-6.25c-1.517 0-2.75 1.233-2.75 2.75v15.5c0 1.517 1.233 2.75 2.75 2.75h6.25z",
    fill: "#1667b7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.25 24h-11.5c-1.517 0-2.75-1.233-2.75-2.75v-14.5c0-1.517 1.233-2.75 2.75-2.75h11.5c1.517 0 2.75 1.233 2.75 2.75v14.5c0 1.517-1.233 2.75-2.75 2.75z",
    fill: "#eceff1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#607d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.25 17h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 21h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 13.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.25 9.5h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 4h-5.75c-1.517 0-2.75 1.233-2.75 2.75v14.5c0 1.517 1.233 2.75 2.75 2.75h5.75v-3h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.75v-2.5h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.75v-2h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.75v-2.5h-3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.75z",
    fill: "#cdd0d2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 15.5h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h3.75z",
    fill: "#546d79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 19.5h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h3.75z",
    fill: "#546d79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 12h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h3.75z",
    fill: "#546d79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 8h-3.75c-.414 0-.75.336-.75.75s.336.75.75.75h3.75z",
    fill: "#546d79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsDone);
export default __webpack_public_path__ + "static/media/projects-done.8c395619bea664f908e46bc20e55ab30.svg";
export { ForwardRef as ReactComponent };